import { instanceEmployee } from '../../../../services/instances';
import type { IHiringPatch, IHiringPayload } from '../types/forms';
import type { IHiringResponse } from '../types/services';

const getHiring = async (params: Record<string, any> = {}): Promise<any> => {
    const response = await instanceEmployee.get<any>('/hiring', { params });
    return response.data;
};

const createHiring = async (data: IHiringPayload): Promise<any> => {
    const response = await instanceEmployee.post<any>('/hiring/create', data);
    console.log(`createHiring data:`, data);
    return response.data;
};

const updateHiring = async (id: number, data: IHiringPatch): Promise<IHiringResponse> => {
    console.log('updateHiring data:', data); // Log the data being sent
    const response = await instanceEmployee.patch<IHiringResponse>(`/hiring/${id}`, data);
    return response.data;
};

const deleteHiring = async (id: number): Promise<void> => {
    await instanceEmployee.delete<void>(`/hiring/${id}`);
};

export { getHiring, createHiring, updateHiring, deleteHiring };
